import {ResultCode, defaultError, WebError, isError, getErrorMsg} from "@hybird/core/error";

const deviceError = {
  SYSTEM_ERROR: defaultError.SYSTEM_ERROR,
  ILLEGAL_ARGUMENT: new ResultCode(11000, "参数异常"),
  NOT_CONNECT: new ResultCode(11001, "未连接"),
  CONNECT_ILLEGAL_ARGUMENT: new ResultCode(11002, "连接失败, 尝试重新连接"),
  PUBLISH_AND_RESULT_NOT_SUCCESS: new ResultCode(11003, "发送消息,设备响应失败"),
  CRETE_BLE_NOT_NETWORK_CONNECT_PROVIDE: new ResultCode(11004, "创建蓝牙协议异常"),
  PROTOCOL_NOT_SUPPORT: new ResultCode(11005, "协议不支持"),
  SUBSCRIBE_ERROR: new ResultCode(11006, "订阅异常"),
  NOT_CONNECT_DEVICE: new ResultCode(11007, "未检测到设备"),
  CONNECT_ERROR: new ResultCode(11008, "连接失败"),
  CLOSE_ERROR: new ResultCode(11009, "关闭连接失败"),
  WRITE_TIMEOUT: new ResultCode(11010, "发送数据超时"),
  SUBSCRIBE_ONE_READ_TIMEOUT: new ResultCode(11011, "设备响应超时"),
  USED_UP_THE_NUMBER_OF_TIMES: new ResultCode(11012, "用完使用次数"),
  NO_FINGERPRINT_RECORDED: new ResultCode(11013, "未录入指纹"),
  DEVICE_LOCKED: new ResultCode(11013, "已锁定设备, 无需调用"),
  EXECUTION_FAILURE: new ResultCode(11014, "执行失败"),
  BEFORE_SEAL_PHOTO_ILLEGAL_ARGUMENT: new ResultCode(11015, "用印前参数异常"),
  UPGRADE_WAIT_SUCCESS_TIMEOUT: new ResultCode(11016, "等待设备重启回调超时"),
  BLE_NOT_FOUND: new ResultCode(11017, "未找到蓝牙设备"),
  BLE_CANCEL: new ResultCode(11017, "用户主动取消连接"),
  INVOKE_ERROR: new ResultCode(11018, "flutter执行失败"),
  FLUTTER_INIT_ERROR: new ResultCode(11019, "flutter初始化失败"),
  CONNECT_NOT_SUPPORT: new ResultCode(11020, "未找到对应的连接方式"),
  NOT_BLE_CONNECT: new ResultCode(11021, "蓝牙已断开连接"),
  WRITE_ERROR: new ResultCode(11022, "发送数据,写入异常"),
  SERIAL_NOT_NUMBER_CONNECT: new ResultCode(11023, "当前选择连接串口设备序列号为{0},非{1}"),
  DEVICE_INITIALIZE: new ResultCode(11024, "设备尚未初始化完成,请刷新后重试"),
  CAMERA_START_ERROR: new ResultCode(11025, "请确认App是否授权相机权限, 切换权限请关闭App后重试"),
  NOT_OPEN_BLUETOOTH: new ResultCode(11026, "请打开蓝牙后重试"),
  DEVICE_USE_NOT_CONNECT: new ResultCode(11027, "设备被占用, 请退出后重试"),
  FINGERPRINT_AUTH_ERROR: new ResultCode(11028, "发起指纹认证失败"),
  LOCATION_PERMISSION_NOT_OPEN: new ResultCode(11029, "请打开系统位置信息开关"),
  FIRMWARE_UPGRADE_NOT_SUPPORT: new ResultCode(11030, "请升级固件后升级镜像"),
  FIRMWARE_UPGRADE_ERROR: new ResultCode(11031, "发起镜像升级失败"),
  CONNECT_BLE_DEVICE_ERROR: new ResultCode(11032, "连接蓝牙异常,尝试重新连接"),
  BEGIN_SEAL_STAMP_ERROR: new ResultCode(11033, "当前章桶印章不一致"),

  RECORD_STOP: new ResultCode(12001, "录制已暂停"),
  RECORD_NOT_SUPPORT: new ResultCode(12002, "当前浏览器不支持录制视频"),
  CAMERA_NOT_SUPPORT_SEAL_DISCERN: new ResultCode(12003, "不支持范围识别, 请前往App"),
  GEOLOCATION_ERROR: new ResultCode(12004, "定位失败"),
  REMOTE_TIMEOUT: new ResultCode(12005, "远程审批超时"),
  PROTOCOL_NOT_SUPPORT_CHANGE: new ResultCode(12006, "切换协议连接后继续使用"),
  PRIVILEGED_SEAL_USAGE: new ResultCode(12007, "特权用印中"),

  PRECORD_ERROR: new ResultCode(13001, "同步失败"),
  PRECORD_TIMEOUT: new ResultCode(13002, "同步数据超时"),
  isError: isError,
  getErrorMsg: getErrorMsg
}

class DeviceResultError extends WebError {
}


export {deviceError, DeviceResultError}